import React from "react";
import { formatDist } from "../util/format";
import IconPhone from "../icons_js/Phone.js";
import IconSmartphone from "../icons_js/Smartphone.js";
import IconMail from "../icons_js/Mail.js";
import IconJob from "../icons_js/Job.js";
import IconGlobe from "../icons_js/Globe.js";
import IconCert from "../icons_js/Certified.js";
import IconGraduation from "../icons_js/Graduation.js";
import IconLocation from "../icons_js/Location.js";
export default function CardContent({ provider }) {
  console.log({ provider, test: "trst" });
  const {
    name,
    firma,
    nachnamePrivatperson,
    vornamePrivatperson,
    address,
    eMail,
    mobil,
    telefon,
    telefon2,
    telefax,
    kontaktbild,
    webseite,
    webseite2,
    abschluesse,
    zertifizierungen,
    ausbildungen,
    arbeitsfeld,
    berufe,
    dist,
    apadrId,
    facebook,
    instagram,
    linkedin,
  } = provider;

  const premium = webseite.includes("Premium Freigeschaltet");

  const image =
    kontaktbild && premium ? `/kontaktbild?apadr_id=${apadrId}` : "";
  // console.log({ image, kontaktbild });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        maxHeight: "100%",
        padding: "50px 20px 20px",
      }}
    >
      {image && <img src={image} width="200" style={{ marginBottom: 20 }} />}
      <h2 style={{ marginBottom: 5 }}>{name}</h2>
      {firma && (
        <span style={{ marginBottom: 10 }}>
          {vornamePrivatperson} {nachnamePrivatperson}
        </span>
      )}
      <div>
        <span style={{ display: "flex", alignItems: "start", gap: 10 }}>
          <IconLocation style={{ width: 20, height: 20, color: "#aaa" }} />
          <span>
            {address && <span>{makeAddress(address)}</span>}
            {dist && <span>({formatDist(dist)})</span>}
          </span>
        </span>
      </div>
      <hr />
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        {eMail && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconMail style={{ width: 20, height: 20, color: "#aaa" }} />
            <a href={`mailto:${eMail}`}>{eMail}</a>
          </span>
        )}
        {mobil && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconSmartphone style={{ width: 20, height: 20, color: "#aaa" }} />
            <a href={`tel:${mobil}`}>{mobil}</a>
          </span>
        )}
        {telefon && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconPhone style={{ width: 20, height: 20, color: "#aaa" }} />
            <a href={`tel:${telefon}`}>{telefon}</a>
          </span>
        )}
        {telefon2 && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconPhone style={{ width: 20, height: 20, color: "#aaa" }} />
            <a href={`tel:${telefon2}`}>{telefon2}</a>
          </span>
        )}
        {telefax && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg
              style={{ width: 20, height: 20, color: "#aaa" }}
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M192 64h197.5L416 90.51V160h64V77.25c0-8.484-3.375-16.62-9.375-22.62l-45.25-45.25C419.4 3.375 411.2 0 402.8 0H160C142.3 0 128 14.33 128 32v128h64V64zM64 128H32C14.38 128 0 142.4 0 160v320c0 17.62 14.38 32 32 32h32c17.62 0 32-14.38 32-32V160C96 142.4 81.63 128 64 128zM480 192H128v288c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V224C512 206.4 497.6 192 480 192zM288 432c0 8.875-7.125 16-16 16h-32C231.1 448 224 440.9 224 432v-32C224 391.1 231.1 384 240 384h32c8.875 0 16 7.125 16 16V432zM288 304c0 8.875-7.125 16-16 16h-32C231.1 320 224 312.9 224 304v-32C224 263.1 231.1 256 240 256h32C280.9 256 288 263.1 288 272V304zM416 432c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16v-32c0-8.875 7.125-16 16-16h32c8.875 0 16 7.125 16 16V432zM416 304c0 8.875-7.125 16-16 16h-32C359.1 320 352 312.9 352 304v-32C352 263.1 359.1 256 368 256h32C408.9 256 416 263.1 416 272V304z" />
            </svg>
            <a href={`tel:${telefax}`}>{telefax}</a> (Fax)
          </span>
        )}
        {webseite2 && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconGlobe style={{ width: 20, height: 20, color: "#aaa" }} />
            <a
              href={`${makeLinkUrl(webseite2)}`}
              target="_blank"
              rel="noreferrer"
            >
              {webseite2}
            </a>
          </span>
        )}

        {facebook && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg
              height="100%"
              // style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              style={{ width: 20, height: 20, color: "#aaa" }}
              version="1.1"
              viewBox="0 0 512 512"
              width="100%"
            >
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-106.468,0l0,-192.915l66.6,0l12.672,-82.621l-79.272,0l0,-53.617c0,-22.603 11.073,-44.636 46.58,-44.636l36.042,0l0,-70.34c0,0 -32.71,-5.582 -63.982,-5.582c-65.288,0 -107.96,39.569 -107.96,111.204l0,62.971l-72.573,0l0,82.621l72.573,0l0,192.915l-191.104,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Z" />
            </svg>
            <a
              href={`${makeLinkUrl(facebook)}`}
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
          </span>
        )}

        {linkedin && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg
              height="100%"
              // style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              style={{ width: 20, height: 20, color: "#aaa" }}
              version="1.1"
              viewBox="0 0 512 512"
              width="100%"
            >
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-288.985,423.278l0,-225.717l-75.04,0l0,225.717l75.04,0Zm270.539,0l0,-129.439c0,-69.333 -37.018,-101.586 -86.381,-101.586c-39.804,0 -57.634,21.891 -67.617,37.266l0,-31.958l-75.021,0c0.995,21.181 0,225.717 0,225.717l75.02,0l0,-126.056c0,-6.748 0.486,-13.492 2.474,-18.315c5.414,-13.475 17.767,-27.434 38.494,-27.434c27.135,0 38.007,20.707 38.007,51.037l0,120.768l75.024,0Zm-307.552,-334.556c-25.674,0 -42.448,16.879 -42.448,39.002c0,21.658 16.264,39.002 41.455,39.002l0.484,0c26.165,0 42.452,-17.344 42.452,-39.002c-0.485,-22.092 -16.241,-38.954 -41.943,-39.002Z" />
            </svg>
            <a
              href={`${makeLinkUrl(linkedin)}`}
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </span>
        )}

        {instagram && (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg
              height="100%"
              // style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              style={{ width: 20, height: 20, color: "#aaa" }}
              version="1.1"
              viewBox="0 0 512 512"
              width="100%"
            >
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-193.446,81c-47.527,0 -53.487,0.201 -72.152,1.053c-18.627,0.85 -31.348,3.808 -42.48,8.135c-11.508,4.472 -21.267,10.456 -30.996,20.184c-9.729,9.729 -15.713,19.489 -20.185,30.996c-4.326,11.132 -7.284,23.853 -8.135,42.48c-0.851,18.665 -1.052,24.625 -1.052,72.152c0,47.527 0.201,53.487 1.052,72.152c0.851,18.627 3.809,31.348 8.135,42.48c4.472,11.507 10.456,21.267 20.185,30.996c9.729,9.729 19.488,15.713 30.996,20.185c11.132,4.326 23.853,7.284 42.48,8.134c18.665,0.852 24.625,1.053 72.152,1.053c47.527,0 53.487,-0.201 72.152,-1.053c18.627,-0.85 31.348,-3.808 42.48,-8.134c11.507,-4.472 21.267,-10.456 30.996,-20.185c9.729,-9.729 15.713,-19.489 20.185,-30.996c4.326,-11.132 7.284,-23.853 8.134,-42.48c0.852,-18.665 1.053,-24.625 1.053,-72.152c0,-47.527 -0.201,-53.487 -1.053,-72.152c-0.85,-18.627 -3.808,-31.348 -8.134,-42.48c-4.472,-11.507 -10.456,-21.267 -20.185,-30.996c-9.729,-9.728 -19.489,-15.712 -30.996,-20.184c-11.132,-4.327 -23.853,-7.285 -42.48,-8.135c-18.665,-0.852 -24.625,-1.053 -72.152,-1.053Zm0,31.532c46.727,0 52.262,0.178 70.715,1.02c17.062,0.779 26.328,3.63 32.495,6.025c8.169,3.175 13.998,6.968 20.122,13.091c6.124,6.124 9.916,11.954 13.091,20.122c2.396,6.167 5.247,15.433 6.025,32.495c0.842,18.453 1.021,23.988 1.021,70.715c0,46.727 -0.179,52.262 -1.021,70.715c-0.778,17.062 -3.629,26.328 -6.025,32.495c-3.175,8.169 -6.967,13.998 -13.091,20.122c-6.124,6.124 -11.953,9.916 -20.122,13.091c-6.167,2.396 -15.433,5.247 -32.495,6.025c-18.45,0.842 -23.985,1.021 -70.715,1.021c-46.73,0 -52.264,-0.179 -70.715,-1.021c-17.062,-0.778 -26.328,-3.629 -32.495,-6.025c-8.169,-3.175 -13.998,-6.967 -20.122,-13.091c-6.124,-6.124 -9.917,-11.953 -13.091,-20.122c-2.396,-6.167 -5.247,-15.433 -6.026,-32.495c-0.842,-18.453 -1.02,-23.988 -1.02,-70.715c0,-46.727 0.178,-52.262 1.02,-70.715c0.779,-17.062 3.63,-26.328 6.026,-32.495c3.174,-8.168 6.967,-13.998 13.091,-20.122c6.124,-6.123 11.953,-9.916 20.122,-13.091c6.167,-2.395 15.433,-5.246 32.495,-6.025c18.453,-0.842 23.988,-1.02 70.715,-1.02Zm0,53.603c-49.631,0 -89.865,40.234 -89.865,89.865c0,49.631 40.234,89.865 89.865,89.865c49.631,0 89.865,-40.234 89.865,-89.865c0,-49.631 -40.234,-89.865 -89.865,-89.865Zm0,148.198c-32.217,0 -58.333,-26.116 -58.333,-58.333c0,-32.217 26.116,-58.333 58.333,-58.333c32.217,0 58.333,26.116 58.333,58.333c0,32.217 -26.116,58.333 -58.333,58.333Zm114.416,-151.748c0,11.598 -9.403,20.999 -21.001,20.999c-11.597,0 -20.999,-9.401 -20.999,-20.999c0,-11.598 9.402,-21 20.999,-21c11.598,0 21.001,9.402 21.001,21Z" />
            </svg>
            <a
              href={`${makeLinkUrl(instagram)}`}
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
          </span>
        )}
      </div>
      <hr />
      {arbeitsfeld && (
        <>
          <span>
            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <IconJob style={{ width: 20, height: 20, color: "#aaa" }} />
              <strong>Arbeitsfeld</strong>
            </span>
            {makeList(arbeitsfeld)}
          </span>
          <hr />
        </>
      )}
      {berufe && (
        <>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconJob style={{ width: 20, height: 20, color: "#aaa" }} />
            <strong>Berufe</strong>
          </span>
          {makeList(berufe)}
          <hr />
        </>
      )}
      {zertifizierungen && (
        <>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconCert style={{ width: 20, height: 20, color: "#aaa" }} />
            <strong>Zertifizierungen</strong>
          </span>
          {makeList(zertifizierungen)}
          <hr />
        </>
      )}
      {ausbildungen && (
        <>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconGraduation style={{ width: 20, height: 20, color: "#aaa" }} />
            <strong>Ausbildungen</strong>
          </span>
          {makeList(ausbildungen)}
          <hr />
        </>
      )}
      {abschluesse && (
        <>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconGraduation style={{ width: 20, height: 20, color: "#aaa" }} />
            <strong>Abschlüsse</strong>
          </span>
          {makeList(abschluesse)}
          <hr />
        </>
      )}
    </div>
  );
}

const makeLinkUrl = (text) => {
  // if no http found add https://
  if (!text.match(/http/)) {
    text = `https://${text}`;
  }
  return text;
};

const makeAddress = (text) => (
  <p style={{ padding: 0, margin: 0 }}>
    {text.split(",").map((row, index) => (
      <span key={index}>
        {row.trim()}
        <br />
      </span>
    ))}
  </p>
);

const makeList = (text) => (
  <ul style={{ padding: "0px 23px", margin: "5px 0px 10px" }}>
    {text.split(",").map((item, index) => (
      <li key={index} style={{ padding: "2px 7px" }}>
        {item.trim()}
      </li>
    ))}
  </ul>
);
